<template>
  <iColumn
    :width="getOptionValue(LayoutWidth)"
    gap="extraSmall"
  >
    <iTextArea
      v-model="applicationMessage"
      :placeholder="getOptionValue(Placeholder)"
      :rows="5"
      width="fill"
    />
  </iColumn>
</template>

<script>
// `~/stores/dynamic-input-store` lives outside the editor directory
// tree. The canvas preview just needs a typable text area — keep
// the value local rather than threading through the dynamic-input
// store.
import { ApplyToCollaboratePageElementMixin }
  from "%/dynamic-component-editor/standard-pages/apply-to-collaborate-page/apply-to-collaborate-page-element-mixin";
import InputOptions from "%/dynamic-component-editor/bundles/input-options";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import Placeholder from "%/dynamic-component-editor/options/placeholder";

export default {
  name: "ApplyToCollaborateMessage",
  elementPanelSettings: {
    displayName: "Application Message",
    displayIcon: "pencil",
    elementType: "element",
    elementGroup: "applyToCollaborateElements",
  },
  mixins: [ApplyToCollaboratePageElementMixin],
  optionBundles: [
    new InputOptions({
      "default.placeholder": "Enter your message here",
    }),
  ],
  data() {
    return {
      LayoutWidth,
      Placeholder,
      applicationMessage: "",
    };
  },
};
</script>

<style scoped lang="scss">
</style>
